<template>
  <div v-if="datas.length" class="wrapper">
    <van-radio-group v-model="radio">
      <van-radio v-for="(item, index) in datas" :key="index" :name="item">
        {{ item.content }}
        <template #icon="props">
          <img
            class="img-icon"
            :src="props.checked ? activeIcon : inactiveIcon"
          />
        </template>
      </van-radio>
    </van-radio-group>
  </div>
</template>

<script>
import { RadioGroup, Radio } from 'vant'
export default {
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  props: {
    datas: {
      type: Array,
      default: () => []
    },
    val: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      radio: {},
      activeIcon:
        'https://hzwimspic-1251601690.image.myqcloud.com/6144dda0-5bec-4f09-b4f6-9be912bffc42',
      inactiveIcon:
        'https://hzwimspic-1251601690.image.myqcloud.com/a3b7f718-792f-4e59-9b52-550fcf59e7de'
    }
  },
  watch: {
    radio() {
      this.$emit('input', this.radio)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/css/mixin.scss';
.wrapper {
  padding-bottom: rem(20px);
}
/deep/ .van-radio {
  margin-top: rem(15px);
  .van-radio__icon {
    height: auto;
  }
  .van-radio__label {
    color: #262626;
    font-size: rem(26px);
  }
}
.img-icon {
  width: rem(40px);
  height: rem(40px);
}
</style>
